import React from 'react';
import { FormattedNumber } from 'react-intl';
import { get as _get } from 'lodash-es';
const defaultCurrency = _get(
  window,
  'compatioConfig.compatibleProducts.currency'
);
const defaultCurrencySub = _get(
  window,
  'compatioConfig.compatibleProducts.currencySub'
);

export const ProductPriceString = ({
  price,
  compareAtPrice,
  currency,
  place = 'Product',
}) => {
  const priceTag = (
    <>
      {place === 'Outfit' ? (
        <p>
          <strong>
            <FormattedNumber
              value={price}
              style="currency"
              currency="USD"
              minimumFractionDigits={2}
              maximumFractionDigits={2}
            />
            {defaultCurrencySub ? ` ` + defaultCurrencySub : ''}
          </strong>
          {price < compareAtPrice && compareAtPrice != 0 ? (
            <strong className="dcdiscountedprice">
              <FormattedNumber
                value={compareAtPrice}
                style="currency"
                currency="USD"
                minimumFractionDigits={2}
                maximumFractionDigits={2}
              />
              {defaultCurrencySub ? ` ` + defaultCurrencySub : ''}
            </strong>
          ) : null}
        </p>
      ) : (
        <span
          className={
            price < compareAtPrice && compareAtPrice != 0
              ? 'discountedprice xrs-product__price dc-product__price'
              : 'regularprice xrs-product__price dc-product__price'
          }
        >
          {price < compareAtPrice && compareAtPrice != 0 ? (
            <span className="dcs-dis-pric">
              <FormattedNumber
                value={compareAtPrice}
                style="currency"
                currency={defaultCurrency ? defaultCurrency : currency}
                minimumFractionDigits={2}
                maximumFractionDigits={2}
              />
              {defaultCurrencySub ? ` ` + defaultCurrencySub : ''}
            </span>
          ) : null}
          <span className="dcs-pric">
            <FormattedNumber
              value={price}
              style="currency"
              currency={defaultCurrency ? defaultCurrency : currency}
              minimumFractionDigits={2}
              maximumFractionDigits={2}
            />
            {defaultCurrencySub ? ` ` + defaultCurrencySub : ''}
          </span>
        </span>
      )}
    </>
  );

  return priceTag;
};
